import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Session handling: single active session + idle timeout are enforced server-side.
api.interceptors.response.use(undefined, async (error) => {
  const { response, config } = error;
  const detail = typeof response?.data?.detail === "string" ? response.data.detail : "";
  if (response?.status === 401 && detail.startsWith("SESSION_")) {
    window.dispatchEvent(new CustomEvent("session-ended", { detail: detail.startsWith("SESSION_IDLE") ? "idle" : "replaced" }));
  } else if (response?.status === 401 && detail === "Token expired" && !config._retried && !config.url.includes("/auth/")) {
    config._retried = true;
    try { await api.post("/auth/refresh"); return api(config); } catch { /* falls through */ }
  }
  return Promise.reject(error);
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtNGN(n) {
  if (n == null) return "₦0";
  return "₦" + Number(n).toLocaleString("en-NG", { maximumFractionDigits: 0 });
}

export function fmtUSD(n) {
  if (n == null) return "$0";
  return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 2 });
}

export function fmtBps(bps) {
  return `${(Number(bps) / 100).toFixed(2)}%`;
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("en-NG", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return s;
  }
}
